import { node, number } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

const DesignLink = ({ id, onClickDesignView, children }) => {
	const handleClick = (e) => {
		e.stopPropagation();
		e.preventDefault();
		if (id) {
			const queryString = `/collections/list?openDesign=true&productId=${encodeURIComponent(id)}`;
			if (e.metaKey || e.ctrlKey) {
				window.open(queryString);
			} else {
				onClickDesignView();
			}
		}
	};
	return (
		<Link
			to={`/collections/list?openDesign=true&productId=${encodeURIComponent(id)}`}
			onClick={handleClick}
			style={{ textDecoration: 'underline' }}
		>
			{children}
		</Link>
	);
};

DesignLink.propTypes = {
	id: number.isRequired,
	children: node.isRequired
};
export default DesignLink;
